export interface FileUploadRequest {
    /** 任务ID */
    taskId: string;
    /** 要上传的文件 */
    file: File;
    /** 内容类型：交底书或权利要求 */
    contentType: 'DISCLOSURE' | 'CLAIM';
}

export interface FileUploadResponse {
    /** 上传是否成功 */
    success: boolean;
}

export const FileUploadApi = Symbol.for('FileUploadApi');

export interface FileUploadApi {
    /**
     * 上传文件到指定任务
     * @param request 文件上传请求参数
     * @returns 上传结果
     */
    uploadFile(request: FileUploadRequest): Promise<FileUploadResponse>;
}
